import { useRouteStore } from "@/Stores/routes";
import { computed } from "vue";
import { router } from "@inertiajs/vue3";
import { useBreakpoints } from "@/Composables/useBreakpoints";

export function useRoutes() {
    const routeStore = useRouteStore();
    const { customRouter } = routeStore;
    const { maxSmall } = useBreakpoints();

    const currentRoute = computed(() => customRouter.currentRoute);
    const previousRoute = computed(() => customRouter.previousRoute);
    const routeHistory = computed(() => customRouter.routes);
    const lastMainRoute = computed(() => customRouter.lastMainRoute);
    const updateRoute = (route) => {
        customRouter.previousRoute = customRouter.currentRoute;
        customRouter.currentRoute = route;
        customRouter.routes.push(route);

        if (
            route.includes("/tasks") ||
            route.includes("/files") ||
            route.includes("/assets") ||
            route.includes("/asset-groups") ||
            route.includes("/spaces")
        ) {
            customRouter.lastMainRoute = route;
        }
    };

    const goBack = () => {
        let url = lastMainRoute.value || "/admin/tasks/all";

        if (previousRoute.value && !previousRoute.value.includes("/settings")) {
            url = previousRoute.value;
        }

        if (
            maxSmall.value &&
            currentRoute.value.includes("/settings") &&
            !currentRoute.value.endsWith("/settings/organisation")
        ) {
            url = "/admin/settings/organisation";
        }

        router.visit(url, {
            preserveScroll: true,
            preserveState: true,
        });
    };

    const clearHistory = () => {
        Object.assign(customRouter, {
            previousRoute: null,
            currentRoute: null,
            routes: [],
        });
    };

    return {
        currentRoute,
        previousRoute,
        lastMainRoute,
        routeHistory,
        updateRoute,
        goBack,
        clearHistory,
    };
}
